<template>
  <el-dialog
    :title="`应${receiveOrPayFlag?'付':'收'}单预览`"
    :visible.sync="dialogVisible"
    width="60%"
    custom-class="rent-order-dialog"

    :before-close="handleClose"
  >
    <preview-rent-order-header
      :payMode="payMode"
      :planAmount="planAmount"
      :payDay="payDay"
      :startStopDate="startStopDate"
      :tableDataFrom.sync="tableDataFrom"
      :payPost="payPost"
    ></preview-rent-order-header>
    <preview-rent-order-main
      ref="previewRentOrderMain"
      :tableDataFrom.sync="tableDataFrom"
      :fundType="fundType"
      @handleDel="handleDel"
    ></preview-rent-order-main>

    <preview-rent-order-footer
      slot="footer"
      :payMode="payMode"
      :planAmount="planAmount"
      :payDay="payDay"
      :fundType="fundType"
      :tableDataFrom.sync="tableDataFrom"
      @confirmBill="confirmBill"
      @close="handleClose"
    ></preview-rent-order-footer>
  </el-dialog>
</template>
<script>
import PreviewRentOrderHeader from './PreviewRentOrderHeader'
import PreviewRentOrderMain from './PreviewRentOrderMain'
import PreviewRentOrderFooter from './PreviewRentOrderFooter'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'PreviewRentOrder',
  inject: ['receiveOrPayFlag'],
  data() {
    return {
      dialogVisible: false,
      tableDataFrom: {
        tableData: [],
      },
      startStopDate: [],
      fundType: '',
      planAmount: '',
      payMode: '',
      dueDate: '',
      payDay: '',
      payPost: 0,
      totalPlanAmount: 0,
    }
  },
  components: {
    PreviewRentOrderHeader,
    PreviewRentOrderMain,
    PreviewRentOrderFooter,
  },
  methods: {
    // 展示弹框
    showDialog(row) {
      // 付款方式-payMode，收款类型-fundType，金额-planAmount,收款起止日-startStopDate,收款类型-fundType
      const dueDate = row.items && row.items.length > 0 && row.items[0].dueDate;
      [
        'payMode',
        'planAmount',
        'fundType',
        'payDay',
        'startStopDate',
        'payPost',
      ].forEach((item) => {
        this[item] = row[item]
      })
      this.totalPlanAmount = 0
      this.dueDate = dueDate
      row.items &&
        row.items.length > 0 &&
        row.items.forEach((item, index) => {
          this.totalPlanAmount += (item.morePlanAmount ? item.morePlanAmount : item.planAmount) * 100
          item.num = index + 1
        })
      const cloneItems = _cloneDeep(row.items)

      // 只有周期详情不为空的时候才进行展示周期详情弹窗
      if (cloneItems.length) {
        // 此赋值单独操作，目的不污染主数据源，不在主数据源添加无关属性（accruedCycle）
        cloneItems.forEach((item) => {
          item.accruedCycle = [item.startCycleDate, item.endCycleDate]
        })
        this.$set(this.tableDataFrom, 'tableData', cloneItems)
        this.dialogVisible = true
      }
    },

    // 关闭弹框
    handleClose() {
      this.dialogVisible = false
      this.tableDataFrom = {}
    },

    // 删除条目
    handleDel(i) {
      this.tableDataFrom.tableData.splice(i, 1)
      this.tableDataFrom.tableData.forEach((item, index) => {
        item.num = index + 1
      })
    },

    // 保存提交数据
    confirmBill(data) {
      const { totalPlanAmount } = this
      let tempTotalPlanAmount = 0
      data.items &&
        data.items.length > 0 &&
        data.items.forEach((item) => {
          tempTotalPlanAmount += item.planAmount * 100
        })

      if (totalPlanAmount < tempTotalPlanAmount) {
        return this.$message.error(
          '当前账单金额超出签署的租金总额，请确认后再次提交',
        )
      }
      this.$refs.previewRentOrderMain.handleValidate().then(() => {
        this.$emit('confirmBill', data)
        this.handleClose()
      })
    },
  },
}
</script>
<style lang="scss">
.rent-order-dialog {
  .el-dialog__body {
    margin: 0 !important;
    margin-top: 16px !important;
  }
  .el-dialog__footer {
    padding: 0 16px !important;
    padding-bottom: 0;
    height: 64px;
    display: flex;
    align-items: center;
  }
}
</style>
